import * as React from 'react';

export class Container<Properties = {
    [key: string]: any
}, State = { [key: string]: any }> extends React.Component<Properties & { automation?: string }, State> {
}
